import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { DocumentService } from 'src/app/core/services/document.service';

@Component({
  selector: 'app-candidate-profile-actions-modal',
  templateUrl: './candidate-profile-actions-modal.component.html'
})
export class CandidateProfileActionsModalComponent implements OnInit {
  resolve: any;
  public onClose = new Subject<any>();

  actionType: any;
  actionLabel: any;
  candidateId: any;
  folder: any;
  document: any;
  parentFolderName: any;
  parentFolders: any;
  showUpload: any;
  documents: any;
  availableDocuments: any;
  folders: any;
  candidateJobMatchFolders: any;
  candidateDetails: any;
  candidateType: any;
  deleteDocumentPayload: any;
  allFoldersList: any;
  isSharedDocumentActionAvailable: any;
  companiesToShareCandidateDocuments: any;
  callbackObject: any;
  sourceScreen: any;
  formalizeActivityPayload: any;
  documentViewUrl!: SafeResourceUrl;
  documentViewUrlWithFit!: SafeResourceUrl;

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService,
    private documentService: DocumentService,
    private sanitizer: DomSanitizer
  ) {
    this.resolve = this.bsModalService.config.initialState;
  }

  ngOnInit() {
    this.actionType = this.resolve.actionType;
    this.actionLabel = this.resolve.actionLabel;
    this.candidateId = this.resolve.candidateId;
    this.folder = this.resolve.folder;
    this.document = this.resolve.document;
    this.parentFolderName = this.resolve.parentFolderName;
    this.parentFolders = this.resolve.parentFolders;
    this.showUpload = this.resolve.showUpload;
    this.documents = this.resolve.documents;
    this.availableDocuments = this.resolve.availableDocuments;
    this.folders = this.resolve.folders;
    this.candidateJobMatchFolders = this.resolve.candidateJobMatchFolders;
    this.candidateDetails = this.resolve.candidateDetails;
    this.candidateType = this.resolve.candidateType;
    this.deleteDocumentPayload = this.resolve.deleteDocumentPayload;
    this.allFoldersList = this.resolve.allFoldersList;
    this.isSharedDocumentActionAvailable = this.resolve.isSharedDocumentActionAvailable;
    this.companiesToShareCandidateDocuments = this.resolve.companiesToShareCandidateDocuments;
    this.callbackObject = { callbackType: 'cancel', entity: {} };
    this.sourceScreen = this.resolve.sourceScreen;
    this.formalizeActivityPayload = this.resolve.formalizeActivityPayload;
    this._setCandidateDocumentViewUrl();
  }

  closeModal() {
    this.onClose.next(this.callbackObject);
    this.bsModalRef.hide();
  }

  dismissModal() {
    this.onClose.next(null);
    this.bsModalRef.hide();
  }

  refresh(folder?: any) {
    this.callbackObject.callbackType = 'refresh';
    if (folder) {
      this.callbackObject.entity = folder;
      this.closeModal();
    }
  }

  attachDocuments(documents: any) {
    this.callbackObject.callbackType = 'attachDocuments';
    this.callbackObject.entity = documents;
    this.closeModal();
  }

  onEmployeeAdded(employee: any) {
    this.onClose.next(employee);
    this.bsModalRef.hide();
  }

  private _setCandidateDocumentViewUrl() {
    if (this.document) {
      const url = this.document.isJobMatchDocument
        ? this.document.link
        : this.documentService.getCandidateDocumentReportUrl(this.document.id);
      this.documentViewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.documentViewUrlWithFit = this.sanitizer.bypassSecurityTrustResourceUrl(url + '#view=fitH');
    }
  }
}
